import { createSlice } from "@reduxjs/toolkit";
import {
  getCardTypes,
  getDonationTypes,
  toGetDonationMethods,
} from "../actions/donation.actions";

const initialState = {
  donationTypes: [] as any,
  cardTypes: [] as any,
  donationMethods: [] as any,
  loading: false,
  error: null as unknown | null,
};
export const donationSlice = createSlice({
  name: "donation",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getDonationTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDonationTypes.fulfilled, (state, action) => {
        state.donationTypes = action.payload;
        state.loading = false;
      })
      .addCase(getDonationTypes.rejected, (state, action) => {
        state.donationTypes = [];
        state.loading = false;
        state.error = action.payload;
      })
      /*--------------------------GET CARD TYPES---------------------------*/
      .addCase(getCardTypes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCardTypes.fulfilled, (state, action) => {
        state.cardTypes = action.payload;
        state.loading = false;
      })
      .addCase(getCardTypes.rejected, (state, action) => {
        state.cardTypes = [];
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(toGetDonationMethods.pending, (state) => {
        state.loading = true;
      })
      .addCase(toGetDonationMethods.fulfilled, (state, action) => {
        state.donationMethods = action.payload;
        state.loading = false;
      })
      .addCase(toGetDonationMethods.rejected, (state, action) => {
        state.donationMethods = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default donationSlice.reducer;
